import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
import I18n from 'I18n';
import TimezoneTypes from '../constants/TimezoneTypes';
// @ts-expect-error untyped JS module
import formatShortDate from '../utils/formatShortDate';
// @ts-expect-error untyped JS module
import formatMediumDate from '../utils/formatMediumDate';
// @ts-expect-error untyped JS module
import formatShortMY from '../utils/formatShortMonthYear';
// @ts-expect-error untyped JS module
import formatMediumMY from '../utils/formatMediumMonthYear';
// @ts-expect-error untyped JS module
import formatShortQY from '../utils/formatShortQuarterYear';
// @ts-expect-error untyped JS module
import formatShortFullDate from '../utils/formatShortFullDate';
// @ts-expect-error untyped JS module
import formatMediumFullDate from '../utils/formatMediumFullDate';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const extraFormats = {
  'short-date': formatShortDate,
  'medium-date': formatMediumDate,
  'short-full-date': formatShortFullDate,
  'medium-full-date': formatMediumFullDate,
  'short-m-y': formatShortMY,
  'medium-m-y': formatMediumMY,
  'short-q-y': formatShortQY
};
function FormattedDateTime(t0) {
  const $ = _c(10);
  const {
    value,
    format,
    type: t1
  } = t0;
  const type = t1 === undefined ? TimezoneTypes.PORTAL : t1;
  useContext(I18nHMRContext);
  const specialFormatter = extraFormats[format];
  let date;
  if (specialFormatter) {
    let t2;
    if ($[0] !== specialFormatter || $[1] !== type || $[2] !== value) {
      t2 = specialFormatter(value, type);
      $[0] = specialFormatter;
      $[1] = type;
      $[2] = value;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    date = t2;
  } else {
    let t2;
    if ($[4] !== format || $[5] !== type || $[6] !== value) {
      t2 = I18n.moment[type](value).format(format);
      $[4] = format;
      $[5] = type;
      $[6] = value;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    date = t2;
  }
  let t2;
  if ($[8] !== date) {
    t2 = /*#__PURE__*/_jsx("span", {
      children: date
    });
    $[8] = date;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
FormattedDateTime.displayName = 'FormattedDateTime';

// Consumers spyOn() this function and we don't want to require the mock to have `displayName`
export default FormattedDateTime;